
import NewComponent from "../../../components/mall_coupons/New.vue";

export default {
  components: {
    NewComponent,
  },
};
